export default "__VITE_ASSET__d893bbe3__"